import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { HlmCarouselComponent } from '../../../../../../spartan_libs/ui-carousel-helm/src/lib/hlm-carousel.component';
import { HlmCarouselItemComponent, HlmCarouselNextComponent, HlmCarouselPreviousComponent,HlmCarouselContentComponent } from '../../../../../../spartan_libs/ui-carousel-helm/src';
import { EmblaCarouselDirective, EmblaOptionsType } from 'embla-carousel-angular';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/ui-dialog-brain';
import * as env from 'environments/environment'
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from '../../utility/data_collector.service';
import { WorkflowService } from '../../workflows/workflow.service';
import { Router } from '@angular/router';
import { TemplateService } from './template.service';
import { FormsModule } from '@angular/forms';
import { BrnSelectImports } from '@spartan-ng/ui-select-brain';
import { HlmSelectImports } from '@spartan-ng/ui-select-helm';
import { CommonModule } from '@angular/common';
import { CardSkeletonComponent } from '../skeleton/card-skeleton/card-skeleton.component';
import { LazyLoaderComponent } from '../lazy-loader/lazy-loader.component';
import moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';


@Component({
  selector: 'app-templates',
  standalone: true,
  imports: [
    CommonModule,
    HlmCarouselComponent, 
    HlmCarouselContentComponent,
    HlmCarouselItemComponent, 
    HlmCarouselNextComponent,
    HlmCarouselPreviousComponent,
    EmblaCarouselDirective,
    HlmButtonDirective,
    FormsModule,
    BrnSelectImports,
    HlmSelectImports,
    CardSkeletonComponent,
    LazyLoaderComponent,
    TranslateModule,
    
  ],
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.scss',
  providers: [DataCollectorService, TemplateService]
})
export class TemplatesComponent implements OnInit {

  @ViewChild(EmblaCarouselDirective) protected emblaCarousel?: EmblaCarouselDirective;

  private readonly _dialogRef = inject<BrnDialogRef<any>>(BrnDialogRef);
  private readonly _dialogContext = injectBrnDialogContext<{ data: any}>();
  protected readonly data = this._dialogContext.data;
  protected options: EmblaOptionsType | undefined
  env: any

  keyword: string;
  currentPage: number = 1;
  count: number = 9;
  totalPages: number = 1;
  totalRecords: number = 0;
  workflowTemplates: any[] = [];
  filter: any = {
    sort: 'DESC',
    sort_by: 'created_at',
    limit: this.count,
    page: this.currentPage,
    'filter.category': ''
  }
  showLoader: boolean = false;
  allCategories: any[] = [];
  selectedCategory: any = '';
  currentCategory: any;

  initialWorkflowData = {
    "workflow": {
        "workflow_name": "Untitled",
        "workflow_description": "",
        "nodes": [],
        "connections": {},
        "is_active": false,
        "meta_data": {}        
    }
  }
  shimmerArr: any[] = Array.from({length: 6}).fill(0);
  selectedTemplate: any = null;


  currentMode: 'SELECTION' | 'TEMPLATES' | 'PREVIEW' = 'SELECTION';

  constructor(
    private _toast: HotToastService,
    private _dataCollectorService: DataCollectorService,
    private _workflowService: WorkflowService,
    private _router: Router,
    private _templateService: TemplateService,
    private _changeDetectorRef: ChangeDetectorRef,
    private localisationService: LocalisationService,
    private analyticService: AnalyticsService

  ){

  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.env = env.environment;
    this.currentMode = 'SELECTION';
  }

  createWorkflowFromTemplate(uid: string): void {
    if(uid){
      const toastLoader = this._toast.loading('Please wait while template is being fetched')
      this._dataCollectorService.getData(this._templateService.apiUrl.templates+`/${uid}`)
      .subscribe({
        next: (res: any) => {
          this.closeModal();
          toastLoader.close();
          const template = res?.data
          this.analyticService.trackEvent('WORKFLOW_TEMPLATE_MODAL_NEW_WORKFLOW');
          if(template?.template_name){
            this.analyticService.trackEvent('WORKFLOW_TEMPLATE_'+template?.template_name)
          }
          const data = {
            'workflow_name': template?.template_name || '',
            'workflow_description': template?.template_description || '',
            'nodes': template?.nodes,
            'connections': template?.connections,
            'meta_data': template?.meta_data,
            'is_active': template?.is_active || true,
            'workflow_template_id': template?.template_uid || '',
          };
          this.createWorkflowWithData({workflow: data});
        },
        error: (err: any) => {
          toastLoader.close();
          if(err?.data?.message){
            this._toast.error(err.data.message);
          }
        }
      })
    }
  }

  goToTemplates(): void {
    this.currentMode = 'TEMPLATES'; 
    this.selectedTemplate = null;
    this.keyword = '';
    this.selectedCategory = ''
  }

  closeModal(): void {
    this._dialogRef.close();
  }

  openTemplate(template: any): void{
    this.selectedTemplate = template;
    this.currentMode = 'PREVIEW';
  }

  clearSearch(): void {
    this.keyword = '';
    this.currentPage = 1;
    const filter = {...this.filter};
    filter['filter.keyword'] = this.keyword;
    this.filter =  filter;
    this.showLoader = true;
    this.getWorkflowTemplates(filter);
  }

  searchKeyword(): void {
    this.currentPage = 1;
    const filter = {...this.filter};
    filter['filter.keyword'] = this.keyword;
    if(this.selectedCategory){
      filter['filter.category'] = this.selectedCategory?.category_uid;
    }
    this.filter = filter
    this.showLoader = true;
    this.getWorkflowTemplates(filter);
  }

  loadTemplates(): void {
    this.currentPage++;
    const filter = {...this.filter}
    filter.page = this.currentPage;
    this.showLoader = true;
    this.getWorkflowTemplates(filter)
  }

  getTemplates(): void {
    this.currentMode = 'TEMPLATES';
    this.showLoader = true;
    this.getWorkflowTemplates(this.filter);
    this.getCategory();
  }

  getCategory(): void {
    this._dataCollectorService.getData(this._templateService.apiUrl.category, {})
      .subscribe({
        next: (res) => {
          this.allCategories = res?.data;
        },
        error: (err) => {
          if(err?.data?.message){
            this._toast.error(err?.data?.message);
          }
        }
      })
  }

  selectCategory(): void {
    this.currentPage = 1;
    this.workflowTemplates = [];
    const filter = {...this.filter};
    if(this.selectedCategory){
      this.currentCategory = this.allCategories.find((category: any) => this.selectedCategory === category?.category_uid)
      filter['filter.category'] = this.selectedCategory;
    }else{
      this.currentCategory = '';
      filter['filter.category'] = ''
    }
    this.filter = {...filter}
    this.showLoader = true;
    this.getWorkflowTemplates(filter);
  }

  getWorkflowTemplates(filter: any): void {
    this._dataCollectorService.getData(this._templateService.apiUrl.templates, filter)
      .subscribe((res: any) => {
        this.totalPages = res?.total_pages;
        this.totalRecords = res?.total_records;
        if(this.currentPage === 1){
          this.workflowTemplates = res?.data;
          if(this.workflowTemplates.length > 10){
            this.count = 10
            this.filter['limit'] = this.count;
            this.currentPage = Math.ceil(this.workflowTemplates.length/this.count);
          }
          this.filter['page'] = this.currentPage;
        }else{
          this.workflowTemplates.push(...res?.data);
        }
        this.showLoader = false;
        this._changeDetectorRef.detectChanges();
      },(err: any) => {
        this.showLoader = false;
        if(err?.message){
          this._toast.error(err?.message);
        }
      })
  }

  createWorkflow(data: any): void {
    this._router.navigateByUrl('/workflow-builder/new-workflow');
    this._dialogRef.close();
  }

  createWorkflowWithData(data: any): void {
    if(data?.workflow?.workflow_name === 'Untitled'){
      data.workflow.workflow_name = `Workflow-${moment().format('DD')}-${moment().format('MMMM')}-${moment().format('YYYY')}-${moment().format('HH')}-${moment().format('mm')}-${moment().format('ss')}`
    }
    const toastLoader = this._toast.loading('Workflow is being initiated')

    const workflowBaseUrl = this._workflowService.apiUrls.workflows;
      this._dataCollectorService.postData(workflowBaseUrl, data)
        .subscribe({
          next: (res: any) => {
            toastLoader.close();
            this._dialogRef.close();
            if(res?.workflow_uid){
              this._router.navigateByUrl('/workflow-builder/workflows/'+res?.workflow_uid)
            }
          },
          error: (err: any) => {
            toastLoader.close();
            if(err?.error?.message){
              this._toast.error(err?.error?.message);
            }
          }
        })
    }

}
